// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2t8VV","owner":"styles_owner__2rtkt"};